import * as React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { EnantisEmailLink, IEnantisEmailLinkProps } from "./enantis-commons";

/**
 * The license alert properties.
 */
export type IEnantisAlertProps = IEnantisEmailLinkProps & {
  toolName: string;
  isOpen: boolean;
  toggle: () => void;
};

/**
 * The license alert component.
 */
export const EnantisAlert: React.FC<IEnantisAlertProps> = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      centered={true}
      fade={false}
      toggle={props.toggle}
    >
      <ModalHeader toggle={props.toggle}>License agreement</ModalHeader>
      <ModalBody>
        {props.toolName} is free to academic users. Commercial users, please
        send email to <EnantisEmailLink {...props} />.
      </ModalBody>
      <ModalFooter>
        <Button onClick={props.toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};
